/* unplugin-vue-components disabled */import { render } from "./TopHomeView.vue?vue&type=template&id=3a765c5e&scoped=true"
import script from "./TopHomeView.vue?vue&type=script&lang=js"
export * from "./TopHomeView.vue?vue&type=script&lang=js"

import "./TopHomeView.vue?vue&type=style&index=0&id=3a765c5e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a765c5e"]])

export default __exports__